define([
	"csi/config/preferences"
], function(configPreferences) {

	return {};

});